export default __webpack_public_path__ + "static/media/rarity-img2-6.1e39adf3.png";